const Footer = () => {
  return (
    <footer>
        Psico Tá On ® | 2021-2023 | Desenvolvido por <a href="https://www.linkedin.com/in/daisyvgs/" target="_blank" rel="noreferrer">Daisy VGS</a>
    </footer>
  )
}

export default Footer